import { render, staticRenderFns } from "./PostEditorFooter.vue?vue&type=template&id=22206422&scoped=true&"
import script from "./PostEditorFooter.vue?vue&type=script&lang=js&"
export * from "./PostEditorFooter.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorFooter.vue?vue&type=style&index=0&id=22206422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22206422",
  null
  
)

export default component.exports